import type { PartialWidgetContext } from '@/types/cms'
import Partials from '@/elements/Partials'
import styles from './GridSidebar.module.scss'
import AppContext from '@/types/context'

export interface GroupGridProps {
  children: Array<PartialWidgetContext>
}

const GridSidebar = ({ item, context }: { item: GroupGridProps; context: AppContext }) => {
  return (
    <aside className={styles.sidebar}>
      {item.children.map((widget: PartialWidgetContext, index) => {
        return <Partials key={index} context={context} item={widget as any} />
      })}
    </aside>
  )
}

export default GridSidebar
